import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'


const initialState = {
  expense_types: [],
  meta_data: [],
  all_expense_types: []
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
